import { ShiftData } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'
import { UserShiftCard } from 'shared/components/shift/user_shift_card'

interface Props {
  shiftData: ShiftData | undefined | null
}

export function SwapCoverDetails({ shiftData }: Props) {
  const styles = useStyles()

  return (
    <View>
      <Text style={styles.title}>{shiftData?.statusMessages.primary}</Text>
      {shiftData?.type === 'SWAP' && (
        <UserShiftCard shift={shiftData?.shift!} />
      )}
      {shiftData?.candidates && (
        <UserShiftCard shift={shiftData?.candidates[0].shift!} />
      )}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  title: {
    margin: 15,
  },
}))
